import { baseStaticUrl } from "../../config";

const AVATAR_SIZE = 60;
const DEFAULT_AVATAR = "default.png";
const DEFAULT_AVATAR_SOURCE = `${baseStaticUrl}/assets/avatar/170x170/${DEFAULT_AVATAR}`;

export { AVATAR_SIZE, DEFAULT_AVATAR, DEFAULT_AVATAR_SOURCE };
